import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
import { ITask } from '../interface/tasks';
import { Entities } from '../interface/common';

interface IFetchTaskDetail {
  id?: string;
  relations?: string[];
  fields?: string[];
  skipGlobalErrorHandler?: boolean;
}
export const useFetchTaskDetail = (params: IFetchTaskDetail) => {
  const { id, skipGlobalErrorHandler, ...queryParams } = params;
  const queryString = Object.keys(queryParams)?.length
    ? toQueryString(queryParams as QueryParamObject)
    : null;
  const taskDetailUrl = `${API_URLS.TASKS_LIST}/${id}`;
  const url = queryString ? `${taskDetailUrl}?${queryString}` : taskDetailUrl;
  const query = useQuery<ITask, Error>({
    queryKey: ['task-details', id],
    queryFn: async () => {
      const response = await get(
        url,
        {},
        {
          headers: {
            entity: Entities.ACTIVITY,
          },
          skipGlobalErrorHandler,
        },
      );
      return response;
    },
    enabled: !!id,
  });

  return query;
};
